import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { Markdown } from '@repo/ui/src/components/Markdown';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { LinkProps } from '@repo/ui/src/types/link';

interface Props {
  title: string;
  description: string;
  linkDisplay: string;
  linkObj: LinkProps;
}

export const TextContainer = ({ title, description, linkDisplay, linkObj }: Props) => (
  <div className="tw-flex tw-flex-col tw-max-w-[550px] tw-align-center tw-h-full tw-align-center">
    {title ? <h2 className="tw-flex tw-pt-1 tra-text-web-heading-5">{title}</h2> : null}
    <hr className="tw-border-2 tw-w-10 tw-border-brand-300 tw-my-4" />
    {description && <Markdown>{description}</Markdown>}
    <div className="tw-w-fit tw-mt-4 tw-ml-0">
      {linkObj && linkDisplay === 'Button' ? (
        <Button
          {...linkObj}
          className="tw-inline-block"
          as={Anchor}
          full
          size="large"
          variant={ButtonVariant.secondary}
          dataTestId="text-container-button"
        >
          {linkObj.displayName}
        </Button>
      ) : (
        <Anchor {...linkObj} dataTestId="text-container-anchor" />
      )}
    </div>
  </div>
);
